module.exports = __webpack_public_path__ + "static/media/banner-0.a0b07128.jpg";